import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useBrowsePrimitivesPageQueryOptions } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.primitives.query";
import { useCallback } from "react";

/** Primitives → List view: primitives grouped by how many characters they appear in. */
function useNavigator() {
  const browsePrimitivesPageQueryOptions = useBrowsePrimitivesPageQueryOptions();

  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/browse/(browse-tabs)/primitives/list",
      },
      queries: [browsePrimitivesPageQueryOptions],
    }),
    [browsePrimitivesPageQueryOptions],
  );
}

export const useBrowsePrimitivesListPageNavigator = createPageNavigator<void>({
  useNavigator,
});
